// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button[data-v-1fe98d1d]{margin-right:12px}.text-big[data-v-1fe98d1d]{font-size:24px}.text-big[data-v-1fe98d1d],.text-small[data-v-1fe98d1d]{text-align:center}", ""]);
// Exports
module.exports = exports;
